import { Link } from "react-router-dom";
import type { MissingField } from "@/lib/brokerProducts";

/** The same missing-answer links on pricing, carrier details and quote. */
export function MissingFieldsList({
  missing,
  missingFieldHref,
  accountHint = false,
  className = "list-inside list-disc",
}: {
  missing: readonly MissingField[];
  missingFieldHref?: (field: MissingField) => string | null;
  accountHint?: boolean;
  className?: string;
}) {
  return (
    <ul className={className}>
      {missing.map((field) => {
        const href = missingFieldHref?.(field);
        return (
          <li key={field.key}>
            {href ? (
              <Link to={href} className="text-brk-accent hover:underline">
                {field.label}
              </Link>
            ) : (
              field.label
            )}
            {!href && accountHint && field.scope === "account" && (
              <span className="text-xs"> — on the insured profile</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
